// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: feed-erros.proto

/**
 * A list of errors that may be thrown during feed ingestion.
 *
 * Next ID: 96
 */
export enum Error {
	/** ERROR_UNSPECIFIED - Unused. */
	ERROR_UNSPECIFIED = 'ERROR_UNSPECIFIED',
	/**
	 * TIMESTAMP_OUT_OF_RANGE - Timestamp represents either a time too early in the past, or too far in
	 * the future to represent a valid value. This error is mainly intended to
	 * catch errors with units, like microseconds vs. milliseconds, or seconds.
	 */
	TIMESTAMP_OUT_OF_RANGE = 'TIMESTAMP_OUT_OF_RANGE',
	/**
	 * DURATION_OUT_OF_RANGE - Duration is either negative, or too large, or too small to represent a
	 * valid duration. This error is mainly intended to catch errors with units,
	 * like microseconds vs. milliseconds, or seconds.
	 */
	DURATION_OUT_OF_RANGE = 'DURATION_OUT_OF_RANGE',
	/**
	 * INVALID_TIME_RANGE - Start time is earlier than end time, or the individual timestamps which
	 * make-up the timerange are themselves out of valid range.
	 */
	INVALID_TIME_RANGE = 'INVALID_TIME_RANGE',
	/**
	 * PRICE_OUT_OF_RANGE - The price is either too small a fraction to be useful (e.g. one millionth
	 * of a dollar), or too large (e.g. one million dollars) to represent a
	 * correct price. Note that zero dollars is accepted and means "free".
	 * This error is mainly intended to catch errors with units, like
	 * microdollars vs. whole dollars.
	 */
	PRICE_OUT_OF_RANGE = 'PRICE_OUT_OF_RANGE',
	/** INVALID_CURRENCY_CODE - The currency code is not supported. */
	INVALID_CURRENCY_CODE = 'INVALID_CURRENCY_CODE',
	/**
	 * TAX_RATE_OUT_OF_RANGE - The tax rate is either too small a fraction to be useful (e.g. one
	 * millionth of a percent), or to large to be a correct tax rate
	 * (e.g. 1000%). Note that zero is accepted and means no tax. This error is
	 * mainly intended to catch errors with units, like micro-percent vs.
	 * percent.
	 */
	TAX_RATE_OUT_OF_RANGE = 'TAX_RATE_OUT_OF_RANGE',
	/**
	 * RECORD_OUT_OF_RESTRICTION - A record was sent within a restriction, but does not belong within that
	 * restriction. e.g. service_availability restrict between Jan 1st 2017 and
	 * Jan 2nd 2017, with an availability slot for Jan 3rd 2017.
	 */
	RECORD_OUT_OF_RESTRICTION = 'RECORD_OUT_OF_RESTRICTION',
	/**
	 * AVAILABILITY_SPOT_COUNT_OUT_OF_RANGE - The total or open spot count of an availability slot is either negative,
	 * or too large to represent a correct spot count (e.g. 1 million spots).
	 */
	AVAILABILITY_SPOT_COUNT_OUT_OF_RANGE = 'AVAILABILITY_SPOT_COUNT_OUT_OF_RANGE',
	/**
	 * AVAILABILITY_RESTRICT_IN_INCREMENTAL_FEED - Restricts are only useful to remove availability slots, and incremental
	 * feeds don’t ever remove slots. Using both together is always a mistake.
	 */
	AVAILABILITY_RESTRICT_IN_INCREMENTAL_FEED = 'AVAILABILITY_RESTRICT_IN_INCREMENTAL_FEED',
	/** MISSING_ID - The id of a Merchant, Service or PaymentOption is missing. */
	MISSING_ID = 'MISSING_ID',
	/**
	 * MISSING_NAME - The name of a Merchant, Service, PaymentOption, or event entity is
	 * missing.
	 */
	MISSING_NAME = 'MISSING_NAME',
	/** MISSING_ADDRESS - The address of a Merchant or Service-level location is missing. */
	MISSING_ADDRESS = 'MISSING_ADDRESS',
	/** MISSING_PRICE - The price of a PaymentOption is missing. */
	MISSING_PRICE = 'MISSING_PRICE',
	/**
	 * CONFLICTING_PAYMENT_OPTION - Multiple payment options with the same payment_option_id are present in
	 * the Merchant feed, and are not identical.
	 */
	CONFLICTING_PAYMENT_OPTION = 'CONFLICTING_PAYMENT_OPTION',
	/** MISSING_RECURRENCE - Used when schedule exceptions are present but no recurrence. */
	MISSING_RECURRENCE = 'MISSING_RECURRENCE',
	/**
	 * SCHEDULE_EXCEPTION_OUT_OF_RECURRENCE - The start of an exception must not exceed the duration of the final
	 * slot. The end of an exception must not terminate before the beginning
	 * of the first slot.
	 */
	SCHEDULE_EXCEPTION_OUT_OF_RECURRENCE = 'SCHEDULE_EXCEPTION_OUT_OF_RECURRENCE',
	/**
	 * TOO_MANY_PAYMENT_OPTIONS - More than one payment option id override was found in an availability
	 * slot. Only one is allowed.
	 */
	TOO_MANY_PAYMENT_OPTIONS = 'TOO_MANY_PAYMENT_OPTIONS',
	/**
	 * MISSING_RESOURCES - Used when staff_id or room_id is provided and the corresponding name
	 * field is empty.
	 */
	MISSING_RESOURCES = 'MISSING_RESOURCES',
	/** TOKENIZATION_CONFIG - The tokenization configuration is malformed. */
	TOKENIZATION_CONFIG = 'TOKENIZATION_CONFIG',
	/** MISSING_REQUIRED_FIELD - Used when a required field is not set. */
	MISSING_REQUIRED_FIELD = 'MISSING_REQUIRED_FIELD',
	/** INVALID_MATCHING_HINTS - The provided MerchantMatchingHints message is invalid. */
	INVALID_MATCHING_HINTS = 'INVALID_MATCHING_HINTS',
	/**
	 * BAD_OR_INELIGIBLE_URL - The given URL is considered harmful and therefore not allowed by Google,
	 * or it is not allowed to be served on Google domains due to FTC Opt-out
	 * regulation.
	 */
	BAD_OR_INELIGIBLE_URL = 'BAD_OR_INELIGIBLE_URL',
	/** INVALID_SERVICE_ATTRIBUTE - The service attribute provided on the merchant was invalid. */
	INVALID_SERVICE_ATTRIBUTE = 'INVALID_SERVICE_ATTRIBUTE',
	/** INVALID_SCHEDULING_RULES - The scheduling rules provided on the service was invalid. */
	INVALID_SCHEDULING_RULES = 'INVALID_SCHEDULING_RULES',
	/** INVALID_WAITLIST_RULES - The waitlist rules message provided on the service was invalid. */
	INVALID_WAITLIST_RULES = 'INVALID_WAITLIST_RULES',
	/** LAST_BOOKABLE_SEC_AFTER_START_SEC - The provided last_bookable_sec is later than the start_sec. */
	LAST_BOOKABLE_SEC_AFTER_START_SEC = 'LAST_BOOKABLE_SEC_AFTER_START_SEC',
	/** FIRST_BOOKABLE_SEC_AFTER_START_SEC - The provided first_bookable_sec is later than the start_sec. */
	FIRST_BOOKABLE_SEC_AFTER_START_SEC = 'FIRST_BOOKABLE_SEC_AFTER_START_SEC',
	/** LAST_ONLINE_CANCELLABLE_SEC_AFTER_START_SEC - The provided last_online_cancellable_sec is later than the start_sec. */
	LAST_ONLINE_CANCELLABLE_SEC_AFTER_START_SEC = 'LAST_ONLINE_CANCELLABLE_SEC_AFTER_START_SEC',
	/** INVALID_SUPPORTED_RESOURCES - The supported_resources message on the merchant was invalid. */
	INVALID_SUPPORTED_RESOURCES = 'INVALID_SUPPORTED_RESOURCES',
	/** RECURRENCE_TOO_LONG - Recurrences over 24h are not supported. */
	RECURRENCE_TOO_LONG = 'RECURRENCE_TOO_LONG',
	/** INVALID_ENTITY - An entity in TicketingVerticalSpecificData is invalid. */
	INVALID_ENTITY = 'INVALID_ENTITY',
	/**
	 * INVALID_ENTITY_TYPE_COMBINATION - An invalid combination of ticketing entity type and event
	 * category/entity role.
	 */
	INVALID_ENTITY_TYPE_COMBINATION = 'INVALID_ENTITY_TYPE_COMBINATION',
	/**
	 * INVALID_PREPAYMENT_TYPE_FOR_PRICE_INTERPRETATION - Indicates the incorrect prepayment type was set for the service's price
	 * display type. E.g. Any service that uses PriceInterpretation.STARTS_AT
	 * must use PrepaymentType.NOT_SUPPORTED.
	 */
	INVALID_PREPAYMENT_TYPE_FOR_PRICE_INTERPRETATION = 'INVALID_PREPAYMENT_TYPE_FOR_PRICE_INTERPRETATION',
	/**
	 * INVALID_SERVICE_TYPE - The type provided on the service is invalid. The aggregator does not have
	 * multiple booking transaction flows scheduling capability, and the type is
	 * not supported by the aggregator vertical. E.g., An appointment-based
	 * service is provided by an order-based aggregator.
	 */
	INVALID_SERVICE_TYPE = 'INVALID_SERVICE_TYPE',
	/** INVALID_SERVICE_NAME - The provided service_name is invalid. */
	INVALID_SERVICE_NAME = 'INVALID_SERVICE_NAME',
	/** INVALID_PREPAYMENT_TERMS - Indicates the provided prepayment terms is invalid. */
	INVALID_PREPAYMENT_TERMS = 'INVALID_PREPAYMENT_TERMS',
	/** MISSING_TEXT - Indicates the localized text message default value is empty. */
	MISSING_TEXT = 'MISSING_TEXT',
	/** MISSING_TEXT_LOCALE - Indicates the locale of a localized text is missing. */
	MISSING_TEXT_LOCALE = 'MISSING_TEXT_LOCALE',
	/** DUPLICATE_TEXT_LOCALE - Indicates duplicate locales in a localized text. */
	DUPLICATE_TEXT_LOCALE = 'DUPLICATE_TEXT_LOCALE',
	/** MISSING_TEXT_VALUE - Indicates the value of a localized text is missing. */
	MISSING_TEXT_VALUE = 'MISSING_TEXT_VALUE',
	/** ABOVE_MAX_TEXT_LENGTH - Indicates a text value is over the max allowable length for that text. */
	ABOVE_MAX_TEXT_LENGTH = 'ABOVE_MAX_TEXT_LENGTH',
	/**
	 * MISSING_SERVICE_LOCATION - Indicates that a service-level location does not contain enough
	 * information. E.g., a service-level location must be supplied at least one
	 * of fields below: place_id, geo_coordinates or description.
	 */
	MISSING_SERVICE_LOCATION = 'MISSING_SERVICE_LOCATION',
	/** INVALID_LOCATION_TYPE - The type provided for the location is invalid. */
	INVALID_LOCATION_TYPE = 'INVALID_LOCATION_TYPE',
	/** DUPLICATE_LOCATION_ID - The location id has duplicates in the same service. */
	DUPLICATE_LOCATION_ID = 'DUPLICATE_LOCATION_ID',
	/** INVALID_LOCATION_ID - The location id is not valid. */
	INVALID_LOCATION_ID = 'INVALID_LOCATION_ID',
	/** INVALID_REFUND_CONDITION - The refund condition provided on the scheduling rule is not valid. */
	INVALID_REFUND_CONDITION = 'INVALID_REFUND_CONDITION',
	/** INVALID_MUSICBRAINZ_ID - MusicBrainz ID provided for an entity is invalid. */
	INVALID_MUSICBRAINZ_ID = 'INVALID_MUSICBRAINZ_ID',
	/** INVALID_RATING - Rating provided is not valid; */
	INVALID_RATING = 'INVALID_RATING',
	/**
	 * INVALID_INTAKE_FORM_FIELDS - The intake form field is not valid. Some fields are only valid for
	 * specific field types.
	 */
	INVALID_INTAKE_FORM_FIELDS = 'INVALID_INTAKE_FORM_FIELDS',
	/** MISSING_TARGET - The target of a Review is missing. */
	MISSING_TARGET = 'MISSING_TARGET',
	/** MISSING_CONTENT - The content (i.e., both rating and text) of a Review is missing. */
	MISSING_CONTENT = 'MISSING_CONTENT',
	/** INVALID_TICKET_REDEMPTION_TYPE - The type provided for the ticket redemption method is invalid. */
	INVALID_TICKET_REDEMPTION_TYPE = 'INVALID_TICKET_REDEMPTION_TYPE',
	/**
	 * INVALID_VIRTUAL_SERVICE_TYPE - ServiceType of a virtual service should always be set as
	 * SERVICE_TYPE_ONLINE_APPOINTMENT.
	 */
	INVALID_VIRTUAL_SERVICE_TYPE = 'INVALID_VIRTUAL_SERVICE_TYPE',
	/**
	 * MISSING_VIRTUAL_SERVICE_PAYMENT_OPTION - This error is shown when there is not valid payment option for the
	 * virtual service.
	 */
	MISSING_VIRTUAL_SERVICE_PAYMENT_OPTION = 'MISSING_VIRTUAL_SERVICE_PAYMENT_OPTION',
	/**
	 * INVALID_DIRECT_MERCHANT_PAYMENT - Direct merchant payment is currently only allowed for virtual service and
	 * not allowed for other service types. Also direct_merchant_payment is not
	 * allowed for service with pre-payment as required.
	 */
	INVALID_DIRECT_MERCHANT_PAYMENT = 'INVALID_DIRECT_MERCHANT_PAYMENT',
	/** DATA_RECORD_ENTITY_EXTRACTION_FAILED - The entity type could not be extracted from the chunked entity value. */
	DATA_RECORD_ENTITY_EXTRACTION_FAILED = 'DATA_RECORD_ENTITY_EXTRACTION_FAILED',
	/** DATA_RECORD_ENTITY_TYPE_EMPTY - The extracted entity type is empty. */
	DATA_RECORD_ENTITY_TYPE_EMPTY = 'DATA_RECORD_ENTITY_TYPE_EMPTY',
	/** DATA_RECORD_MISSING_ENTITY_KEY - The extracted entity type does not have a Key configuration. */
	DATA_RECORD_MISSING_ENTITY_KEY = 'DATA_RECORD_MISSING_ENTITY_KEY',
	/**
	 * DATA_RECORD_INVALID_KEY_EXTRACTORS - Key extractors could not be built from the rules specified in the feed
	 * configuration.
	 */
	DATA_RECORD_INVALID_KEY_EXTRACTORS = 'DATA_RECORD_INVALID_KEY_EXTRACTORS',
	/** DATA_RECORD_INVALID_ENTITY_TYPE - The extracted entity type is not valid. */
	DATA_RECORD_INVALID_ENTITY_TYPE = 'DATA_RECORD_INVALID_ENTITY_TYPE',
	/** DATA_RECORD_KEY_EXTRACTION_FAILED - An entity key could not be extracted from the chunked entity value. */
	DATA_RECORD_KEY_EXTRACTION_FAILED = 'DATA_RECORD_KEY_EXTRACTION_FAILED',
	/** PROTO_KEY_EXTRACTION_FAILED - The primary key could not be extracted from the entity value. */
	PROTO_KEY_EXTRACTION_FAILED = 'PROTO_KEY_EXTRACTION_FAILED',
	/** DUPLICATE_KEY_DETECTED - Duplicate primary keys were detected in the feed. */
	DUPLICATE_KEY_DETECTED = 'DUPLICATE_KEY_DETECTED',
	/** INVALID_KEY_DETECTED - Primary key is using disallowed characters. */
	INVALID_KEY_DETECTED = 'INVALID_KEY_DETECTED',
	/** F2_WRITE_FAILED - The CDS F2 write failed. */
	F2_WRITE_FAILED = 'F2_WRITE_FAILED',
	/**
	 * UNSUPPORTED_ACTION_TYPE_FOR_FOOD_ORDERING_METADATA - [END Generic Feed error types]
	 * The merchant or service contains action links for an action type that //
	 * may not support food ordering metadata.
	 */
	UNSUPPORTED_ACTION_TYPE_FOR_FOOD_ORDERING_METADATA = 'UNSUPPORTED_ACTION_TYPE_FOR_FOOD_ORDERING_METADATA',
	/**
	 * INVALID_ACTION_LINK_FOOD_ORDERING_METADATA - The merchant or service contains action links with invalid food ordering
	 * metadata.
	 */
	INVALID_ACTION_LINK_FOOD_ORDERING_METADATA = 'INVALID_ACTION_LINK_FOOD_ORDERING_METADATA',
	/** DATA_RECORD_ENTITY_VALUE_PARSING_FAILED - The chunked entity value could not be parsed from the input file. */
	DATA_RECORD_ENTITY_VALUE_PARSING_FAILED = 'DATA_RECORD_ENTITY_VALUE_PARSING_FAILED',
	/** INVALID_RANKING_HINT - The service ranking hint is invalid. */
	INVALID_RANKING_HINT = 'INVALID_RANKING_HINT',
	/** DUPLICATE_UNSUPPORTED_PARTY_SIZE_OPTION - Duplicate option of UnsupportedPartySizeOption has been set. */
	DUPLICATE_UNSUPPORTED_PARTY_SIZE_OPTION = 'DUPLICATE_UNSUPPORTED_PARTY_SIZE_OPTION',
	/** UNSUPPORTED_PARTY_SIZE_OPTION_KIND_EMPTY - UnsupportedPartySizeOption must have a value. */
	UNSUPPORTED_PARTY_SIZE_OPTION_KIND_EMPTY = 'UNSUPPORTED_PARTY_SIZE_OPTION_KIND_EMPTY',
	/** UNSUPPORTED_RESERVATION_LINKOUT_TEMPLATE - Reservation linkout experience is not supported. */
	UNSUPPORTED_RESERVATION_LINKOUT_TEMPLATE = 'UNSUPPORTED_RESERVATION_LINKOUT_TEMPLATE',
	/**
	 * UNSUPPORTED_LINKOUT_REQUIRED_REASON - Reservation linkout experience, which uses linkout_required_reason, is
	 * not supported.
	 */
	UNSUPPORTED_LINKOUT_REQUIRED_REASON = 'UNSUPPORTED_LINKOUT_REQUIRED_REASON',
	/** DUPLICATE_SERVICE_NAMES - A merchant has services with duplicate names within a locale. */
	DUPLICATE_SERVICE_NAMES = 'DUPLICATE_SERVICE_NAMES',
	/** PROVIDED_SERVICE_DESCRIPTIONS_BELOW_THRESHOLD - A merchant is missing descriptions for many of its services. */
	PROVIDED_SERVICE_DESCRIPTIONS_BELOW_THRESHOLD = 'PROVIDED_SERVICE_DESCRIPTIONS_BELOW_THRESHOLD',
	/** DUPLICATE_SERVICES - A merchant has services with duplicate (name, duration, category, price). */
	DUPLICATE_SERVICES = 'DUPLICATE_SERVICES',
	/**
	 * PROTO_ENTITY_PARSING_FAILED - The entity type could not be extracted from a proto value in an input
	 * file.
	 */
	PROTO_ENTITY_PARSING_FAILED = 'PROTO_ENTITY_PARSING_FAILED',
	/** DUPLICATE_ENTITY_ID - An ActionDetail has the same Entity ID as another */
	DUPLICATE_ENTITY_ID = 'DUPLICATE_ENTITY_ID',
	/** EMPTY_ACTION_LINK - The action link is empty */
	EMPTY_ACTION_LINK = 'EMPTY_ACTION_LINK',
	/** MISSING_LINK_ACTIONS - The Action link does not contain any Actions */
	MISSING_LINK_ACTIONS = 'MISSING_LINK_ACTIONS',
	/** MISSING_ENTITY_LOCATION - The Entity is missing it's location field */
	MISSING_ENTITY_LOCATION = 'MISSING_ENTITY_LOCATION',
	/** INVALID_SERVICE_ID - The service_id is invalid. */
	INVALID_SERVICE_ID = 'INVALID_SERVICE_ID',
	/** INVALID_TEXT_LOCALE - The text locale is invalid. */
	INVALID_TEXT_LOCALE = 'INVALID_TEXT_LOCALE',
	/** ROOM_DESCRIPTION_MISSING_DEFAULT_VALUE - The room description is missing default text field. */
	ROOM_DESCRIPTION_MISSING_DEFAULT_VALUE = 'ROOM_DESCRIPTION_MISSING_DEFAULT_VALUE',
	/** MISSING_PRICE_INFO - Indicates the provided prepayment is missing price info. */
	MISSING_PRICE_INFO = 'MISSING_PRICE_INFO',
	/** PREPAYMENT_PRICE_RANGE_INVERSION - Indicates the prepayment price range is invalid. */
	PREPAYMENT_PRICE_RANGE_INVERSION = 'PREPAYMENT_PRICE_RANGE_INVERSION',
	/**
	 * PREPAYMENT_PRICE_RANGE_EQUAL - Indicates the prepayment price range is equal to the min price, in this
	 * case single price should be used.
	 */
	PREPAYMENT_PRICE_RANGE_EQUAL = 'PREPAYMENT_PRICE_RANGE_EQUAL',
	/** URI_TEMPLATE_MISSING - The URI template proto is provided but template string is missing. */
	URI_TEMPLATE_MISSING = 'URI_TEMPLATE_MISSING',
	/** URI_TEMPLATE_MISSING_REQUIRED_PARAMETERS - The URI template is missing required parameters. */
	URI_TEMPLATE_MISSING_REQUIRED_PARAMETERS = 'URI_TEMPLATE_MISSING_REQUIRED_PARAMETERS',
	/** URI_TEMPLATE_UNSUPPORTED_PARAMS - The URI template has unsupported parameters. */
	URI_TEMPLATE_UNSUPPORTED_PARAMS = 'URI_TEMPLATE_UNSUPPORTED_PARAMS',
	/**
	 * INVALID_ACTION_LINK_DINING_METADATA - The merchant or service contains action links with invalid dining
	 * metadata.
	 */
	INVALID_ACTION_LINK_DINING_METADATA = 'INVALID_ACTION_LINK_DINING_METADATA',
	/**
	 * REDIRECT_NOT_ENABLED_FOR_ENVIRONMENT - The service contains uri template for redirect integration, but the
	 * feature is not enabled for the environment.
	 */
	REDIRECT_NOT_ENABLED_FOR_ENVIRONMENT = 'REDIRECT_NOT_ENABLED_FOR_ENVIRONMENT',
	/**
	 * NON_CANONICAL_URL - The given URL is not canonical. For details on URL canonicalization, see
	 * http://shortn/_VbL8UOdKSK.
	 */
	NON_CANONICAL_URL = 'NON_CANONICAL_URL',
	/**
	 * INVALID_MERCHANT_ID - The service's merchant_id is invalid.
	 * No merchant with the given merchant_id was found.
	 */
	INVALID_MERCHANT_ID = 'INVALID_MERCHANT_ID',
	UNRECOGNIZED = 'UNRECOGNIZED',
}
